import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import {numberFormat} from "../../../../../../services/helpers";
import { selectDefTableSize } from '../../../../../../selectors/screenSelectors';
import CheckboxFilter from "../../../../../common/table/Checkbox";
import createSelect from '../../../../../common/table/createSelect';
import NumberInput from '../../../../../common/table/NumberInput';
import DatePicker from '../../../../../common/table/DatePicker';
import StringInput from '../../../../../common/table/StringInput';

class Table extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className={`table-main-wrap table-main-wrap_register ${this.props.propsGetDataStatus == 'pending' ? 'table-main-wrap_loading' : '' }`}>
                <div className="table-header">Інформація про талони</div>
                <ReactTable
                    pageSize={this.props.pageSize}
                    page={this.props.page}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onPageChange={this.props.handleChangePage}
                    manual={true}
                    filterable
                    sortable
                    multiSort
                    onFilteredChange={this.props.handleOnFilterChange}
                    onSortedChange={this.props.handleOnSortChange}
                    filtered={this.props.filtered}
                    sorted={this.props.sorted}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    getTheadFilterThProps={(rowInfo) => {
                        return {
                            style: {
                                overflow: 'visible',
                                textAlign: 'left'
                            }
                        }
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({
                                        id: rowInfo.row._original.ID,
                                        index: rowInfo.index
                                    });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer'
                                }
                            }
                        }else{
                            return {}
                        }
                    }}
                    data={this.props.propsArraySort}
                    columns={[
                        {
                            Header: "",
                            filterable: false,
                            sortable: false,
                            width: 30,
                            id: "IsValid&IsCovered",
                            accessor: item => {
                                return item.IsValid && item.IsCovered ? (
                                    <i className="red circle" />
                                ) : ''
                            }
                        },
                        {
                            Filter: StringInput,
                            id: 'Employee/Department/Company/Name',
                            Header: "Компанія",
                            accessor: "Employee.Department.Company.Name"
                        },
                        {
                            Filter: StringInput,
                            id: 'Employee/Department/Name',
                            Header: "Відділ",
                            accessor: "Employee.Department.Name",
                        },
                        {
                            Filter: StringInput,
                            id: 'Employee/Name|Employee/Surname|Employee/Patronymic',
                            Header: "Працівник",
                            accessor: item => {
                                return `${item.Employee.Surname} ${item.Employee.Name} ${item.Employee.Patronymic}`
                            },
                        },
                        {
                            Filter: createSelect({ options: this.props.data.fuelList, placeholder: 'Виберіть' }),
                            minWidth: 150,
                            Header: "Вид палива",
                            id: "TypeFuelID",
                            className: "rightAlign",
                            accessor: item => {
                                return item.TypeFuel === null ? '-------------' : item.TypeFuel.FuelName
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 150,
                            Header: "Об’єм, л.",
                            id: "Capacity",
                            className: "rightAlign",
                            accessor: item => {
                                return !item.Capacity ? '' : numberFormat(item.Capacity)
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 150,
                            Header: "Ціна",
                            id: "Price",
                            className: "rightAlign",
                            accessor: item => {
                                return !item.Price ? '-----------' : numberFormat(item.Price)
                            }
                        },
                        {
                            Filter: DatePicker,
                            minWidth: 170,
                            Header: "Створений",
                            id: "Created",
                            accessor: item => {
                                return new Date(item.Created).toLocaleString()
                            }
                        },
                        {
                            Filter: DatePicker,
                            minWidth: 170,
                            Header: "Дійсний до",
                            id: "Valid",
                            accessor: item => {
                                return !item.Valid ? '-----------' : new Date(item.Valid).toLocaleString()
                            }
                        },
                        {
                            Filter: CheckboxFilter,
                            minWidth: 150,
                            Header: "Частково покривається",
                            id: "Partially",
                            accessor: item => {
                                return <input type="checkbox" checked={item.Partially ? true : false} readOnly/>
                            }
                        },
                        {
                            Filter: createSelect({ options: this.props.typeTerm, placeholder: 'Виберіть' }),
                            Header: "Частково за період",
                            minWidth: 150,
                            id: "TypeTermID",
                            accessor: item => {
                                return !item.TypeTerm ? '-----------' : item.TypeTerm.TermName
                            },
                        },
                        {
                            Filter: CheckboxFilter,
                            Header: "Роздрукований",
                            minWidth: 150,
                            id: "Printed",
                            accessor: item => {
                                return <input type="checkbox" checked={item.Printed ? true : false} readOnly/>
                            }
                        },
                        {
                            Filter: CheckboxFilter,
                            minWidth: 150,
                            Header: "Дійсний",
                            id: "IsValid",
                            accessor: item => {
                                return <input type="checkbox" checked={item.IsValid ? true : false} readOnly/>
                            }
                        },
                        {
                            Filter: CheckboxFilter,
                            minWidth: 150,
                            Header: "Покритий",
                            id: "IsCovered",
                            accessor: item => {
                                return <input type="checkbox" checked={item.IsCovered ? true : false} readOnly/>
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 150,
                            Header: "Залишок, л",
                            id: "BalanceCapacity",
                            accessor: item => {
                                return numberFormat(item.BalanceCapacity || 0)
                            }
                        },
                    ]}
                    defaultPageSize={this.props.defaultPageSize}
                    className=" -highlight"
                    NoDataComponent={() => null}
                    previousText="Назад"
                    nextText="Вперед"
                    rowsText="рядків"
                    pageText="Сторінка"
                    ofText="з"
                />
                <div className="loading"></div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        defaultPageSize: selectDefTableSize(state),
        typeTerm: typeof state.user.data.typeTermList != "undefined" ? state.user.data.typeTermList: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
       dispatch
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
